import styled from 'styled-components';
import { VisuallyHidden } from '../../../../../utils.styles';
import { playFontIcon } from '../../../../../typography/helpers';
import { iconCheck } from '../../../../../design-tokens';

export const RemoveItemsButtonIcon = styled.span`
    margin-right: 8px;
    &:before {
        ${playFontIcon(1.3, iconCheck)}
        vertical-align: text-top;
    }
`;

export const RemoveItemsButtonText = styled.span`
    &:hover {
        text-decoration: underline;
    }
`;

export const A11yText = styled.span`
    ${VisuallyHidden};
`;
